export default "skymp5-front/fdeba2df8780e08f44b195ba68be71b4.mp3";